<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        :persistent="loading"
    >
        <v-card>
            <v-card-title
                style="background-color: #009688; color: white;"
            >
                Do you want to delete this record?
            </v-card-title>
            <v-card-text>
                <v-simple-table
                    dense
                    style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px"
                >
                    <template #default>
                        <tbody>
                            <tr>
                                <td class="text-left">
                                    MSU_CODE
                                </td>
                                <td>{{ tempData && tempData.MSU_CODE ? tempData.MSU_CODE : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    NAME
                                </td>
                                <td>{{ tempData && tempData.NAME ? tempData.NAME : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    DESIGNATION
                                </td>
                                <td>{{ tempData && tempData.DESIGNATION ? tempData.DESIGNATION : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    PREFIX
                                </td>
                                <td>{{ tempData && tempData.PREFIX ? tempData.PREFIX : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    FNAME
                                </td>
                                <td>{{ tempData && tempData.FNAME ? tempData.FNAME : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    SNAME
                                </td>
                                <td>{{ tempData && tempData.SNAME ? tempData.SNAME : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    SUFFIX
                                </td>
                                <td>{{ tempData && tempData.SUFFIX ? tempData.SUFFIX : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACU Contact Person
                                </td>
                                <td>{{ tempData && tempData.ACU_CONTACT_PERSON ? tempData.ACU_CONTACT_PERSON : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACU Contact No
                                </td>
                                <td>{{ tempData && tempData.ACU_CLINIC_TELNO ? tempData.ACU_CLINIC_TELNO : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACU Schedule
                                </td>
                                <td>{{ tempData && tempData.ACU_SCHEDULE ? tempData.ACU_SCHEDULE : '-' }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="teal darken-1"
                    outlined
                    width="120"
                    :disabled="loading"
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                    close
                </v-btn>
                <v-btn
                    color="teal darken-1"
                    width="120"
                    style="color: white;"
                    :loading="loading"
                    @click="submitForm"
                >
                    <v-icon>{{ mdiCheck }}</v-icon>
                    delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'
export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        loading: false,
        tempData: {
            NAME: null,
            MSU_CODE: null,
            PREFIX: null,
            FNAME: null,
            SNAME: null,
            SUFFIX: null,
            DESIGNATION: null,
            ACU_SCHEDULE: null,
            ACU_CONTACT_PERSON: null,
            ACU_CLINIC_TELNO: null
        }
    }),
    computed: {
        ...mapGetters(['deleteProviderAcuInfoData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.handleCloseDialog()
            }
        }
    },
    watch: {
        deleteProviderAcuInfoData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Successfully removed the entry.'
                    this.notif.show = true
                    this.handleCloseDialog(true)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
            this.loading = false
        },
        data(newVal) {
            if (newVal) {
                this.tempData = newVal
            }
        }
    },
    methods: {
        ...mapActions(['deleteProviderAcuInfo', 'viewProviderAcuInfo']),
        handleCloseDialog(data = null) {
            this.$emit('closeDialog', data)
        },
        submitForm() {
            this.loading = true
            this.deleteProviderAcuInfo({ MSU_C: this.tempData.MSU_CODE })
        }
    }
}
</script>
